import React from 'react';
import tpl from '../templates/miniCasco';
import BaseNewCardView from '../../../../Cards/views/BaseNewCardView';

export default class extends BaseNewCardView {
    template = tpl;

    constructor(props, context) {
        super(props, context);

        const ssrData = context && context.ssrData;

        this.state = {
            ...this.state,
            tab: 'insurer-info',
            tabShortInsuranceInfo: 'vuso-short',
            tabFullInsuranceInfo: 'vuso-full',
            detailedInfoVusoWidget: (ssrData && ssrData.detailedInfoVusoWidget) || [],
            detailedInfoVusoWidget_loading: !(ssrData && ssrData.detailedInfoVusoWidget),
            detailedInfoEvroinsWidget: (ssrData && ssrData.detailedInfoEvroinsWidget) || [],
            detailedInfoEvroinsWidget_loading: !(ssrData && ssrData.detailedInfoEvroinsWidget),
            detailedInfoUniqaWidget: (ssrData && ssrData.detailedInfoUniqaWidget) || [],
            detailedInfoUniqaWidget_loading: !(ssrData && ssrData.detailedInfoUniqaWidget),
            detailedInfoArxWidget: (ssrData && ssrData.detailedInfoArxWidget) || [],
            detailedInfoArxWidget_loading: !(ssrData && ssrData.detailedInfoArxWidget),
            detailedInfoUniversWidget: (ssrData && ssrData.detailedInfoUniversWidget) || [],
            detailedInfoUniversWidget_loading: !(ssrData && ssrData.detailedInfoUniversWidget)
        };
    }

    toggleShortInsuranceInfoTab = tab => {
        this.setState({tabShortInsuranceInfo: tab});
    };

    toggleFullInsuranceInfoTab = tab => {
        this.setState({tabFullInsuranceInfo: tab});
    };

    componentDidMount() {
        super.componentDidMount();
        const widgets = [
            {path: '/services/mini-casco_vuso', widgetKey: 'detailedInfoVusoWidget'},
            {path: '/services/mini-casco_evroins', widgetKey: 'detailedInfoEvroinsWidget'},
            {path: '/services/mini-casco_uniqa', widgetKey: 'detailedInfoUniqaWidget'},
            {path: '/services/mini-casco_arx', widgetKey: 'detailedInfoArxWidget'},
            {path: '/services/mini-casco_univers', widgetKey: 'detailedInfoUniversWidget'}
        ];
        widgets.forEach(({path, widgetKey}) => {
            if (this.state[`${widgetKey}_loading`]) {
                this.widgetsHelper.getWidgetsByPath.call(this, {path, widgetKey});
            }
        });
    }

    static displayName = 'MiniCasco';
}
